import React, { useEffect, useState, } from 'react'
import { useParams } from 'react-router';

import axios from 'axios';

import useAuth from '../../controllers/users/useAuth';

import {
    checkIfCallPrinterAsync, responseGet, globalSettings, styles, sendMessageCloseCurrentWindowAsync, dateTimeFormatGlobalSet, separatorsNumbersSet,
    awaitDelay, languageObjGet, isUndNullEmp, LoadingSection
} from '../../helpers/settings';
import HtmlParser from 'react-html-parser';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { receiptModelGet } from '../../models/receipts/receipt';
import { buildingModelGet } from '../../models/buildings/building';

const currentMethod = 'ReceiptsVariationsPrint';
const neutralValue = 0.00;

const { app, icons, images, labels, messages, } = globalSettings;
const { backend, } = app;

export default function ReceiptsVariationsPrint({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region others
    let result;
    let headerObj = {};
    const auth = useAuth();
    const { id, } = useParams();
    //#endregion others

    //#region building
    const [building, setBuilding] = useState(buildingModelGet({}));
    //#endregion building

    //#region reportShow
    const [showLoading, setShowLoading] = useState(true);
    //#endregion reportShow

    //#region variation
    const [variation, setVariation] = useState({
        buildingId: '',
        userId: '',
        building: buildingModelGet({}),
        user: {},
        // variations: [{
        //     percentage: neutralValue,
        // }],
        variations: [],
        filter: '',
        method: '',
    });
    //#endregion Variation

    //#region user
    const [user, setUser] = useState({});
    //#endregion user

    //#region methods
    const dataGetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let variationLocal = {};
            let showPrinterPrompLocal = false;
            //#endregion variables

            setShowLoading(true);

            //#region get expense concept variation (tmp)
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    languageId: languageObj?.id,
                },
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlReports}/${id}`,
            };

            result = await axios?.get(
                headerObj?.url,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: true,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            variationLocal = response?.result;
            setVariation(variationLocal);
            //#endregion get expense concept variation (tmp)

            //#region building get
            setBuilding(variationLocal?.building);
            //#endregion building get

            //#region user get
            setUser(variationLocal?.user);
            //#endregion building get

            //#region show printer promp
            response = await checkIfCallPrinterAsync({
                checkIfOnlyIsMobile: false,
                subMethod: currentMethod,
            });

            if (!response.isSuccess) {
                setShowLoading(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: true,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            showPrinterPrompLocal = response?.result || false;

            setShowLoading(false);

            if (showPrinterPrompLocal) {
                //await new Promise(r => setTimeout(r, globalSettings?.timers?.oneSecond));
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                window?.addEventListener('load', window?.print());
            }
            //#endregion show printer promp
        } catch (ex) {
            setShowLoading(false);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: true,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataDetailGet = ({
        processType,
        variation = {
            id: '',
            ...receiptModelGet({}),
            price: neutralValue,
            details: {
                price: neutralValue,
            },
            percentage: neutralValue,
        },
        subMethod = '',
    }) => {
        const currentMethod = 'dataDetailGet';
        let response = responseGet();
        try {
            switch (processType) {
                case 0:
                    response.result = variation?.id;
                    break;
                case 1:
                    response.result = variation?.number;
                    break;
                case 2:
                    response.result = variation?.description;
                    break;
                case 3:
                    response.result = dateTimeFormatGlobalSet({
                        date: variation?.from,
                        type: languageObj?.format?.date?.f1,
                        format: 0,
                        addTime: false,
                        secondsShow: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result;
                    break;
                case 4:
                    response.result = separatorsNumbersSet({
                        number: variation?.details?.price,
                        withDecimals: true,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result;
                    break;
                case 5:
                    response.result = separatorsNumbersSet({
                        number: variation?.percentage,
                        withDecimals: true,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result;
                    break;
                case 6:
                    response.result = variation?.percentage;
                    break;
                default:
                    break;
            }
        } catch (ex) {
            //setShowLoading(false);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
    }, [id]) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <div>
            {/* <div style={{margin: '3px'}}> */}
            {!showLoading ?
                <div className='container mt-4'>

                    <div className='card card-outline card-secondary elevation-3 shadow-lg'>
                        <div className='card-header'>
                            <h5 className='card-title'>
                                <img src={images?.appLogo}
                                    alt='appLogo'
                                    className='brand-image img-circle elevation-3'
                                    style={styles.receiptPrintLogo} />
                                {app?.name}

                                <div className='text-muted' style={{ fontSize: '13px' }}>
                                    {HtmlParser(globalSettings?.html?.space?.formatSevenTeen)}{messages?.theOnlyAndBestProgramInCondominiumManagement?.[languageObj?.id]}
                                </div>
                            </h5>

                            <div className='card-tools text-small'>
                                <ul className='list-unstyled float-right'>
                                    <li>
                                        {`${labels?.date?.[languageObj?.id]}:`} <b>{`${dateTimeFormatGlobalSet({
                                            date: new Date(),
                                            type: languageObj?.format?.date?.f1,
                                            format: 0,
                                            addTime: false,
                                            secondsShow: false,
                                            languageId: languageObj?.id,
                                            subMethod: 'label - headDate',
                                        })?.result}`}</b>
                                    </li>
                                    <li>
                                        {`${labels?.time?.[languageObj?.id]}:`} <b>{`${dateTimeFormatGlobalSet({
                                            date: new Date(),
                                            type: '',
                                            format: languageObj?.format?.time?.type,
                                            addTime: false,
                                            secondsShow: false,
                                            languageId: languageObj?.id,
                                            subMethod: 'label - headTime',
                                        })?.result}`}</b>
                                    </li>
                                    <li>
                                        {`${labels?.user?.[languageObj?.id]}:`} <b>{
                                            !isUndNullEmp({ data: user?.displayName, subMethod: 'label - user', })?.result ?
                                                user?.displayName :
                                                !isUndNullEmp({ data: user?.firstName, subMethod: 'label - user', })?.result ?
                                                    `${user?.firstName || ''}, ${user?.lastName || ''}` : ''
                                        }</b>
                                    </li>
                                </ul>
                            </div>

                            {/* <div className='row'>
                                    <div className='col-12'>
                                        <h4 className='page-header'>
                                            <img src={images?.appLogo} 
                                                alt='appLogo' 
                                                className='brand-image img-circle elevation-3'
                                                style={styles.receiptPrintLogo} /> {app?.name}
                                            <ul className='list-unstyled float-right'>
                                                <li>
                                                    <small>{`${labels?.date?.[languageObj?.id]}: ${dateTimeFormatSetTwo(new Date(), 'd/m/y', 0)}`}</small>
                                                </li>
                                                <li>
                                                    <small>{`${labels?.time?.[languageObj?.id]}: ${dateTimeFormatSetTwo(new Date(), '', 12)}`}</small>
                                                </li>
                                            </ul>
                                        </h4>
                                    </div>
                                </div> */}
                        </div>
                        <div className='card-body'>

                            {/* <div className='row'> */}
                            <div className='text-center'>
                                <h5>
                                    {labels?.receipts?.[languageObj?.id]} <br />
                                    <b>({labels?.variations?.[languageObj?.id]?.toLowerCase()})</b>
                                </h5>
                            </div>
                            {/* </div> */}

                            <section className='invoice'>

                                {/* title row */}
                                {/* <div className='row'>
                                        <div className='col-12'>
                                            <h4 className='page-header'>
                                                <img src={images?.appLogo} 
                                                    alt='appLogo' 
                                                    className='brand-image img-circle elevation-3'
                                                    style={styles.receiptPrintLogo} /> {app?.name}
                                                <ul className='list-unstyled float-right'>
                                                    <li>
                                                        <small>{`${labels?.date?.[languageObj?.id]}: ${dateTimeFormatSetTwo(new Date(), 'd/m/y', 0)}`}</small>
                                                    </li>
                                                    <li>
                                                        <small>{`${labels?.time?.[languageObj?.id]}: ${dateTimeFormatSetTwo(new Date(), '', 12)}`}</small>
                                                    </li>
                                                </ul>
                                            </h4>
                                        </div>
                                    </div> */}
                                {/* 
                                    <div className='row'>
                                        <div className='cold-12'>
                                            <hr />
                                        </div>
                                    </div> */}

                                {/* info row */}
                                <div className='row invoice-info'>
                                    <div className='col-sm-4 invoice-col'>
                                        <address className='mx-2'>
                                            {labels?.building?.[languageObj?.id]}: <b>{building?.description || ''}</b><br />
                                            {labels?.phone?.[languageObj?.id]}: {building?.phoneNumber || ''}<br />
                                            {labels?.address?.[languageObj?.id]}: {building?.address || ''}<br />
                                            {labels?.email?.[languageObj?.id]}: {building?.email || ''}<br />
                                            {/* <i className='far fa-building'></i> <b>{!isUndefined(building.description) ? building.description : ''}</b><br/>
                                                <i className='fas fa-mobile-alt'></i> {!isUndefined(building.phoneNumber) ? building.phoneNumber : ''}<br/>
                                                <i className={icons?.mapMarker}></i> {!isUndefined(building.address) ? building.address : ''}<br/>
                                                <i className={icons?.envelope}></i> {!isUndefined(building.email) ? building.email : ''}<br/> */}
                                        </address>
                                    </div>
                                    {/* /.col */}
                                    <div className='col-sm-4 invoice-col border-left'>
                                        <address>
                                            {/* {labels?.concept?.[languageObj?.id]}: <b>{variation?.expenseConcept?.description || ''}</b><br /> */}
                                            {labels?.date?.[languageObj?.id]}: <b>{
                                                dateTimeFormatGlobalSet({
                                                    date: new Date(),
                                                    type: languageObj?.format?.date?.f1,
                                                    format: 0,
                                                    addTime: false,
                                                    secondsShow: false,
                                                    languageId: languageObj?.id,
                                                    subMethod: 'label - reportHeaderDate',
                                                })?.result
                                            }</b><br />
                                            {/* {labels?.account?.[languageObj?.id]}: <b>{!isUndefined(bankAccount) && !isUndefined(bankAccount.number) ? bankAccount.number : ''}</b><br/>
                                                {labels?.type?.[languageObj?.id]}: <b>{!isUndefined(bankAccount) && !isUndefined(bankAccount.type) 
                                                    ? (bankAccount.type === 'C' 
                                                        ? labels?.current?.[languageObj?.id] 
                                                            : labels?.savings?.[languageObj?.id]) 
                                                                                : ''}</b><br/>
                                                {labels?.coin?.[languageObj?.id]}: <b>{!isUndefined(coin) && !isUndefined(coin.description) ? coin.description : ''}</b><br/>
                                               
                                                {labels?.initialBalance?.[languageObj?.id]}: <b>{!isUndefined(bankAccount) 
                                                    ? separatorsNumbersSet(numberSet(bankAccount.initialBalance, 'd')) 
                                                        : numberSet('', 'd')}</b><br/>
                                                {labels?.currentBalance?.[languageObj?.id]}: <b>{!isUndefined(bankAccount) 
                                                    ? separatorsNumbersSet(numberSet((bankAccount.currentBalance), 'd')) 
                                                        : numberSet('', 'd')}</b><br/>
                                                 {labels?.status?.[languageObj?.id]}: <b>{!isUndefined(bankAccount) 
                                                    ? (bankAccount.inactive 
                                                        ? labels?.inactive?.[languageObj?.id] 
                                                            : labels?.active?.[languageObj?.id]) : ''}</b><br/> */}
                                        </address>

                                    </div>
                                    {/* /.col */}
                                    <div className='col-sm-4 invoice-col border-left'>
                                        {labels?.filters?.[languageObj?.id]}:<br />
                                        {labels?.value?.[languageObj?.id]}: <b>{variation.filter || ''}</b><br />

                                        {/* {labels?.from?.[languageObj?.id]}: <b>{`${!isUndefined(variation.dateFrom) && !isUndefined(variation.dateFrom.seconds) 
                                                ? dateTimeFormatSet(variation.dateFrom.seconds, 'd/m/y', 0) 
                                                    : dateTimeFormatSetTwo(variation.dateFrom, 'd/m/y', 0, true)}`}</b><br/>
                                            {labels?.to?.[languageObj?.id]}: <b>{`${!isUndefined(variation.dateTo) && !isUndefined(variation.dateTo.seconds) 
                                                ? dateTimeFormatSet(variation.dateTo.seconds, 'd/m/y', 0) 
                                                    : dateTimeFormatSetTwo(variation.dateTo, 'd/m/y', 0, true)}`}</b><br/>
                                            {labels?.variation?.[languageObj?.id]}: <b>{`${!isUndefined(variation.type) 
                                                ? (variation.type === 'a' 
                                                    ? labels?.all?.[languageObj?.id] : (variation.type === 'i' 
                                                        ? labels?.incomes?.[languageObj?.id] : (variation.type === 'e' 
                                                            ? labels?.egresses?.[languageObj?.id] : ''))) : ''}`}</b><br/> */}
                                    </div>
                                    {/* /.col */}
                                </div>

                                {/* /.row */}
                                {/* Table row */}
                                <div className='row'>
                                    <div className='col-12 table-responsive'>
                                        <table className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}>
                                            <thead>
                                                <tr>
                                                    <th style={{ width: '10%' }}>{labels?.receipt?.[languageObj?.id]}</th>
                                                    <th style={{ width: '45%' }}>{labels?.description?.[languageObj?.id]}</th>
                                                    <th style={{ width: '10%' }}>{labels?.date?.[languageObj?.id]}</th>
                                                    <th style={{ width: '15%' }} className='text-right'>{labels?.amount?.[languageObj?.id]}</th>
                                                    <th style={{ width: '20%' }} className='text-right'>{labels?.variation?.[languageObj?.id]}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {variation?.variations?.length > 0 ?
                                                    variation?.variations?.map((detail) => (
                                                        <tr key={dataDetailGet({ processType: 0, variation: detail, subMethod: 'table - detail 0', })?.result}>
                                                            <td>{dataDetailGet({ processType: 1, variation: detail, subMethod: 'table - detail 1', })?.result}</td>
                                                            {/* <td style={{fontSize: '13px'}}>{dataDetailGet(2, detail)?.result}</td> */}
                                                            <td>{dataDetailGet({ processType: 2, variation: detail, subMethod: 'table - detail 2', })?.result}</td>
                                                            <td>{dataDetailGet({ processType: 3, variation: detail, subMethod: 'table - detail 3', })?.result}</td>
                                                            <td className='text-right'>{dataDetailGet({ processType: 4, variation: detail, subMethod: 'table - detail 4', })?.result}</td>
                                                            {/* <td className='text-right'>{dataDetailGet(4, detail)?.result}</td> */}
                                                            {
                                                                detail?.percentage === 0.00 ?
                                                                    <td className='text-right text-primary'><i className={icons?.caretRight}></i> {
                                                                        dataDetailGet({ processType: 5, variation: detail, subMethod: 'table - detail 5.1', })?.result
                                                                    }%</td>
                                                                    :
                                                                    detail?.percentage < 0.00 ?
                                                                        <td className='text-right text-success'><i className={icons?.caretDown}></i> {
                                                                            dataDetailGet({ processType: 5, variation: detail, subMethod: 'table - detail 5.2', })?.result
                                                                        }%</td>
                                                                        :
                                                                        <td className='text-right text-warning'><i className={icons?.caretUp}></i> {
                                                                            dataDetailGet({ processType: 5, variation: detail, subMethod: 'table - detail 5.3', })?.result
                                                                        }%</td>
                                                            }
                                                        </tr>
                                                    ))
                                                    :
                                                    <></>
                                                }
                                                {/* {!isUndefined(movementDetails) && movementDetails.length > 0 ?
                                                        map(movementDetails, (detail) => (
                                                            <tr key={detail.id}>
                                                                <td>{detail.date}</td>
                                                                <td>{detail.reference}</td>
                                                                <td className='text-right'>{detail.amount}</td>
                                                                <td className='text-right'>{detail.balance}</td>
                                                            </tr>
                                                        )) : null
                                                    } */}
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* /.col */}
                                </div>

                                <hr />

                                {/* /.row */}
                                <div className='row'>
                                    {/* accepted payments column */}
                                    {/* <div className='col-6'>
                                            <p className='lead'>{labels?.paymentMethods?.[languageObj?.id]}:</p>
                                            <img className='mx-1 elevation-3' src={images?.visaLogo} alt='visa' />
                                            <img className='elevation-3'src={images?.masterCardLogo} alt='mastercard' />
                                            <img className='mx-1 elevation-3' src={images?.americanExpressLogo} alt='americanExpress' />
                                            <img className='elevation-3'src={images?.payPalLogo} alt='paypal' />
                                            <img className='mx-1 elevation-3' src={images?.zelleLogo} alt='zelle' />
                                            <img className='elevation-3' src={images?.bankTransferLogo} alt='bankTranfer' />
                                            <p className='text-muted well well-sm shadow-none' style={{marginTop: 10}}>
                                            </p>
                                        </div> */}
                                    {/* /.col */}
                                    {/* <div className='col-6'>
                                            <p className='lead'></p>
                                            <div className='table-responsive'>
                                                <table className='table table-sm'>
                                                    <tbody><tr>
                                                        <th style={{width: '50%'}}>{labels?.subTotal?.[languageObj?.id]}:</th>
                                                        <td className='text-right'>{separatorsNumbersSet(apartmentReceipt.total)}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>{labels?.tax.es} (0.00%):</th>
                                                        <td className='text-right'>0.00</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Total:</th>
                                                        <td className='text-right'>{apartmentReceipt.total}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div> */}
                                    {/* /.col */}

                                    <div className='col-sm-3 col-6'>
                                        <div className='description-block border-right'>
                                            {/* <span className='description-percentage text-primary'><i className={icons?.caretLeft}></i> {!isUndefined(variation.previousBalance) 
                                                        ? separatorsNumbersSet(variation.previousBalance) 
                                                            : numberSet('', 'd')}</span> */}
                                            <h5 className='description-header'>---</h5>
                                            {/* <span className='description-text'>{labels?.previousBalance?.[languageObj?.id]}</span> */}
                                        </div>

                                    </div>

                                    <div className='col-sm-3 col-6'>
                                        <div className='description-block border-right'>
                                            {/* <span className='description-percentage text-success'><i className={icons?.caretUp}></i> {!isUndefined(variation.income) 
                                                        ? separatorsNumbersSet(variation.income) 
                                                            : numberSet('', 'd')}</span> */}
                                            <h5 className='description-header'>---</h5>
                                            {/* <span className='description-text'>{labels?.incomes?.[languageObj?.id]}</span> */}
                                        </div>

                                    </div>

                                    <div className='col-sm-3 col-6'>
                                        <div className='description-block border-right'>
                                            {/* <span className='description-percentage text-danger'><i className={icons?.caretDown}></i> {!isUndefined(variation.expense) 
                                                        ? separatorsNumbersSet(variation.expense) 
                                                            : numberSet('', 'd')}</span> */}
                                            <h5 className='description-header'>---</h5>
                                            {/* <span className='description-text'>{labels?.egresses?.[languageObj?.id]}</span> */}
                                        </div>

                                    </div>

                                    <div className='col-sm-3 col-6'>
                                        <div className='description-block'>
                                            {/* <span className={!isUndefined(variation.movementAmount) ? (variation.movementAmount < 0 ? 'description-percentage text-danger' : (variation.movementAmount > 0 ? 'description-percentage text-success' : 'description-percentage text-primary')) : ''}>
                                                        <i className={!isUndefined(variation.movementAmount) ? (variation.movementAmount < 0 ? {icons?.caretDown} : (variation.movementAmount > 0 ? {icons?.caretUp} : icons?.caretRight)) : ''}></i> {!isUndefined(variation.movementAmount) 
                                                            ? separatorsNumbersSet(variation.movementAmount) 
                                                                : numberSet('', 'd')}
                                                    </span> */}
                                            <h5 className='description-header'>---</h5>
                                            {/* <span className='description-text'>{labels?.variation?.[languageObj?.id]}</span> */}
                                        </div>

                                    </div>
                                </div>
                                {/* /.row */}

                                <div className='row'>
                                    <div className='col-12'>
                                        <hr style={{ height: '0.5' }} />
                                    </div>
                                </div>

                                <div className='row text-center' style={{ fontSize: 12 }}>
                                    <div className='col-sm-3 text-muted'>
                                        {`${app?.company?.name} `}
                                    </div>
                                    <div className='col-sm-3 text-muted'>
                                        {`${app?.company?.slogan}`}
                                    </div>
                                    <div className='col-sm-3 text-muted'>
                                        {`${app?.company?.url}`}
                                    </div>
                                    <div className='col-sm-3 text-muted'>
                                        {`${app?.name} / ${app?.version} / ${app?.year}`}
                                    </div>
                                </div>

                            </section>

                        </div>
                    </div>

                </div>
                :
                <div className='text-center'
                    style={{ paddingTop: '50px', }}>
                    <LoadingSection alt='loadingSection'
                        className={globalSettings?.react?.html?.overlay?.textMued}
                        //className='overlay text-muted'
                        showText={true}
                        text={messages?.processing?.[languageObj?.id]}
                        height={25}
                        hidden={!showLoading}
                        languageId={languageObj?.id}
                        width={25}
                        subMethod={currentMethod} />
                </div>
            }

            {/* </div> */}
        </div>
    )
}